import { combineReducers } from 'redux';
import { SET_DOCUMENTS_DATA } from './type';

const initDocumentsData = null;

function documentsData(state = initDocumentsData, action) {
  const { type, documentsData } = action;

  switch (type) {
    case SET_DOCUMENTS_DATA:
      return documentsData;
      break;

    default:
      return state;
  }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function () {
  return combineReducers({
    documentsData,
  });
}
